import angular from 'angular';

class ProductsService {
  constructor($http, localStorageService, Endpoints) {
    'ngInject';

    Object.assign(this, {
      $http,
      localStorageService,
      Endpoints
    });
  }

  getProducts() {
    return this.$http.get(this.Endpoints.products_adminsvc.productsAll);
  }

  getProductsByCode(service_code) {
    return this.$http.get(this.Endpoints.products_adminsvc.productsByService.replace(":service_code", service_code));
  }

  getProductGroupsByCode(code) {
    return this.$http.get(this.Endpoints.groups.productGroupsByCode.replace(":code", code));
  }

  editProduct(code, payload) {
    return this.$http.put(this.Endpoints.products_adminsvc.productByCode.replace(":code", encodeURIComponent(code)), payload);
  }

  cloneProduct(code, payload) {
    return this.$http.post(this.Endpoints.products_adminsvc.cloneProduct.replace(":code", encodeURIComponent(code)), payload);
  }

}

ProductsService.$inject = ["$http", "localStorageService", "Endpoints"];
angular.module('pims').service('ProductsService', ProductsService);